<template>
  <v-container>
    <v-card
      style="background-color: transparent; border-radius: 15px"
      elevation="1"
      width="100vw"
      heigth="100px"
    >
      <v-card-text>
        <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
        <div v-else>
          <AppCalendar :items="events" @adiar="adiar" />
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import AppCalendar from "@/components/calendar/calendar";
import customerApi from "@/shared/pitchCustomerApi";

export default {
  name: "CustomerCalendar",
  components: { AppCalendar },
  created() {
    this.loadData();
  },
  data() {
    return {
      loading: true,
      events: [],
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      customerApi.calendar().then((res) => {
        this.events = res.data.events;
        this.loading = false;
      });
    },
    adiar(item) {
      let request;
      const { action } = item;
      switch (action) {
        case "cancel": {
          if (window.confirm("Confirmar cancelamento da aula?")) {
            request = customerApi.cancelarAula(item.item.id);
          }
          break;
        }
        case "next": {
          request = customerApi.adiarParaProxima(item.item.id);
          break;
        }
        case "other": {
          request = customerApi.postergate(item.item.id, item.item.data);
          break;
        }
        default:
          return;
      }
      request.then(() => {
        this.$root.$emit("display-alert", {
          text: "solicitação de alteração enviada! 😉",
          type: 0,
        });
        this.loadData();
      });
    },
  },
};
</script>
